import React from 'react'
import MainContainer from '../component/MainContainer'
import FAQ from '../component/FAQ'
import Testimonialswiper from '../component/Testimonialswiper'
import Demo from '../component/Demo'
import Abouthome from '../component/Abouthome'
import Counter from '../component/Counter'
import Notificationscroll from '../component/Notificationscroll'
import ContentSection from '../component/ContentSection'

const notification = {
    data: [
        { userName: 'Company 1', logo: '/logo/1.png' },
        { userName: 'Company 2', logo: '/logo/2.png' },
        { userName: 'Company 3', logo: '/logo/3.png' },
        { userName: 'Company 1', logo: '/logo/4.png' },
        { userName: 'Company 2', logo: '/logo/5.png' },
        { userName: 'Company 3', logo: '/logo/6.png' },
        { userName: 'Company 1', logo: '/logo/7.png' },
        { userName: 'Company 2', logo: '/logo/8.png' },
        { userName: 'Company 3', logo: '/logo/9.png' },
        { userName: 'Company 1', logo: '/logo/10.png' },

    ],
};
const Home = () => {
    const firstSectionData = {
        title: "Our Legacy",
        subtitle: "Success Stories",
        description: "PMC Oman has played a pivotal role in advising and managing landmark projects that have reshaped industries. Our portfolio reflects the breadth of our expertise.",
        buttonText: "Free consultation",
        buttonLink: "/contact_us",
        imageUrl: "/img/666917.jpg",
        imageAlt: "Our Legacy Success Stories",
        items: [
            "Corporate & Financial Advisory for Regional Enterprises",
            "Investment Strategy & Risk Management for Infrastructure Development",
            "Cost & Budget Optimization for High-Value Construction Initiatives",
            "Consulting for Large-Scale Hospitality & Commercial Projects"
        ]
    };
    const secondSectionData = {
        title: "Technical Supervision",
        subtitle: "Ensuring Quality, Compliance & On-Site Control",
        description: "PMC Oman provides independent technical supervision to support projects during execution. Our on-site oversight focuses on compliance with approved designs, specifications, and regulatory requirements, helping maintain quality, manage risks, and monitor construction progress effectively.",
        buttonText: "Learn More",
        buttonLink: "/services/technical-supervision",
        imageUrl: "/img/technical.jpg",
        imageAlt: "Technical Supervision",
        items: [
            "On-site monitoring aligned with approved drawings and standards",
            "Quality checks on materials, workmanship, and execution",
            "Compliance with local regulations, safety standards, and contracts",
            "Structured reporting on progress, issues, and corrective actions"
        ],
        reverseLayout: true,
        backgroundColor: "#f8f9fa"
    };
    return (
        <div
            data-elementor-type="wp-page"
            data-elementor-id="18"
            className="elementor elementor-18"
        >
            <MainContainer />

            {/* <div
            className="elementor-element elementor-element-3b03e73 e-con-full qodef-elementor-content-grid e-flex e-con e-child "
            data-id="3b1c742"
            data-aos="fade-up"
               data-aos-offset="200" data-aos-easing="ease-in-sine" data-aos-duration="600"
            data-element_type="container"
            style={{"--padding-top:":"0px"}}
        >

            <div className="elementor-widget-container"> */}


            <Notificationscroll userNames={notification.data} speed={20000} />
            {/* </div>
            </div> */}
            <Abouthome />
            <div
                className="elementor-element elementor-element-8974271 e-con-full e-flex e-con e-parent e-lazyloaded fadeInUp animated"
                data-id={8974271}
                data-element_type="container"
                data-aos="fade-up"
                data-aos-offset="200" data-aos-easing="ease-in-sine" data-aos-duration="600"
                data-settings='{"background_background":"classic"}'
            >
                <div
                    className="elementor-element elementor-element-69fbb22 elementor-widget__width-initial elementor-widget elementor-widget-startpro_core_section_title"
                    data-id="69fbb22"
                    data-element_type="widget"
                    data-widget_type="startpro_core_section_title.default"
                    data-aos="fade-right"
                    data-aos-offset="200" data-aos-easing="ease-in-sine" data-aos-duration="600"
                // style={{marginLeft:"auto",marginRight:"auto",width:"1300px",maxWidth:"1300px"}}
                >
                    {/* <div className="elementor-widget-container">
                        <div className="qodef-shortcode qodef-m  qodef-section-title qodef-alignment--left ">
                            <h2 className="qodef-m-title">Our Services </h2>
                        </div>
                    </div> */}
                </div>
                <div
                    className="elementor-element elementor-element-4b33979 elementor-widget elementor-widget-startpro_core_blog_list"
                    data-id="4b33979"
                    data-element_type="widget"
                    data-widget_type="startpro_core_blog_list.default"
                >
                    <div className="elementor-widget-container" style={{ padding: "0 0 0 0" }}>
                        <div
                            className="qodef-shortcode qodef-m  qodef-blog qodef--list qodef-item-layout--standard qodef-image-border-radius--yes qodef-grid qodef-layout--columns   qodef-vertical-gutter--wide qodef-col-num--4 qodef-item-layout--standard  qodef-pagination--off qodef-responsive--custom qodef-col-num--1512--4 qodef-col-num--1368--4 qodef-col-num--1200--4 qodef-col-num--1024--2 qodef-col-num--880--2 qodef-col-num--680--1 qodef-swiper--show-pagination"
                            data-options='{"plugin":"startpro_core","module":"blog\/shortcodes","shortcode":"blog-list","post_type":"post","next_page":"2","max_pages_num":1,"behavior":"columns","images_proportion":"full","columns":"4","columns_responsive":"custom","columns_1512":"4","columns_1368":"4","columns_1200":"4","columns_1024":"2","columns_880":"2","columns_680":"1","vertical_space":"wide","posts_per_page":"4","orderby":"date","order":"DESC","additional_params":"tax","tax":"category","tax_slug":"consulting","layout":"standard","title_tag":"h5","image_border_radius":"yes","pagination_type":"no-pagination","object_class_name":"StartProCore_Blog_List_Shortcode","taxonomy_filter":"category","additional_query_args":{"tax_query":[{"taxonomy":"category","field":"slug","terms":"consulting"}]},"holder_styles":[]}'
                        >
                            <div className="grid-container dirdd">
                                <article className="qodef-e qodef-blog-item qodef-grid-item qodef-item--full post-2964 post type-post status-publish format-standard has-post-thumbnail hentry category-consulting tag-articles tag-market done-ar"></article>
                                <article className="qodef-e qodef-blog-item qodef-grid-item qodef-item--full post-2964 post type-post status-publish format-standard has-post-thumbnail hentry category-consulting tag-articles tag-market ">
                                    <h2 className="qodef-m-title">Our Services </h2>
                                    <div className="qodef-e-inner">
                                        <div className="qodef-e-top-holder">
                                            <div className="qodef-e-info">
                                                <a
                                                    href="/service/projects_management"
                                                    rel="tag"
                                                >
                                                    Project Management
                                                </a>
                                                <div className="qodef-info-separator-end" />

                                            </div>
                                            <h5 className="qodef-e-title entry-title webkit" style={{ fontSize: "17px" }} title=" Expert oversight from conception to completion">
                                                <a

                                                    className="qodef-e-title-link"
                                                    href="/service/projects_management"
                                                >
                                                    Expert oversight from conception to completion
                                                </a>
                                            </h5>
                                        </div>
                                        <div className="qodef-e-content">
                                            <div className="qodef-e-media">
                                                <div className="qodef-e-media-image">
                                                    <a

                                                        href="/service/projects_management"
                                                    >
                                                        <img
                                                            loading="lazy"
                                                            decoding="async"
                                                            width={860}
                                                            height={1100}
                                                            style={{ aspectRatio: "3/4", objectFit: "cover" }}
                                                            src="/img/blog-img-7.jpg"
                                                            className="attachment-full size-full"
                                                            alt="w"

                                                            sizes="(max-width: 860px) 100vw, 860px"
                                                        />{" "}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </article>
                                <article className="qodef-e qodef-blog-item qodef-grid-item qodef-item--full post-2953 post type-post status-publish format-standard has-post-thumbnail hentry category-consulting tag-articles tag-market">
                                    <h2 className="qodef-m-title" style={{ visibility: "hidden" }}> Our Service</h2>
                                    <div className="qodef-e-inner">
                                        <div className="qodef-e-top-holder">
                                            <div className="qodef-e-info">
                                                <a
                                                    href="/service/management_consultancy"
                                                    rel="tag"
                                                >
                                                    Management Consultancy
                                                </a>
                                                <div className="qodef-info-separator-end" />

                                            </div>
                                            <h5 className="qodef-e-title entry-title webkit" style={{ fontSize: "17px" }} title="Innovative strategies that integrate digital">
                                                <a

                                                    className="qodef-e-title-link"
                                                    href="/service/management_consultancy"
                                                >
                                                    Innovative strategies<br /> that integrate digital
                                                </a>
                                            </h5>
                                        </div>
                                        <div className="qodef-e-content">
                                            <div className="qodef-e-media">
                                                <div className="qodef-e-media-image">
                                                    <a

                                                        href="/service/management_consultancy"
                                                    >
                                                        <img
                                                            loading="lazy"
                                                            decoding="async"
                                                            width={860}
                                                            height={1100}
                                                            style={{ aspectRatio: "3/4", objectFit: "cover" }}
                                                            src="/service/innovative.jpg"
                                                            className="attachment-full size-full"
                                                            alt="w"

                                                            sizes="(max-width: 860px) 100vw, 860px"
                                                        />{" "}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </article>
                                <article className="qodef-e qodef-blog-item qodef-grid-item qodef-item--full post-2951 post type-post status-publish format-standard has-post-thumbnail hentry category-consulting tag-articles tag-market">
                                    <h2 className="qodef-m-title" style={{ visibility: "hidden" }}> Our Service</h2>
                                    <div className="qodef-e-inner">
                                        <div className="qodef-e-top-holder">
                                            <div className="qodef-e-info">
                                                <a
                                                    href="/service/arbitrary_&_legal"
                                                    rel="tag"
                                                >
                                                    Arbitrary and Legal Services
                                                </a>
                                                <div className="qodef-info-separator-end" />

                                            </div>
                                            <h5 className="qodef-e-title entry-title webkit" style={{ fontSize: "17px" }} title="Robust financial planning and risk management">
                                                <a

                                                    className="qodef-e-title-link"
                                                    href="/service/arbitrary_&_legal"
                                                >
                                                    Reliable dispute resolution and legal guidance tailored to protect your business interests

                                                </a>
                                            </h5>
                                        </div>
                                        <div className="qodef-e-content">
                                            <div className="qodef-e-media">
                                                <div className="qodef-e-media-image">
                                                    <a

                                                        href="/service/arbitrary_&_legal"
                                                    >
                                                        <img
                                                            loading="lazy"
                                                            decoding="async"
                                                            width={860}
                                                            height={1100}
                                                            style={{ aspectRatio: "3/4", objectFit: "cover" }}
                                                            src="/img/blog-img-6.jpg"
                                                            className="attachment-full size-full"
                                                            alt="w"

                                                            sizes="(max-width: 860px) 100vw, 860px"
                                                        />{" "}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </article>
                                <article className="qodef-e qodef-blog-item qodef-grid-item qodef-item--full post-2964 post type-post status-publish format-standard has-post-thumbnail hentry category-consulting tag-articles tag-market"></article>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="elementor-element elementor-element-3b1c742 e-con-full qodef-elementor-content-grid e-flex e-con e-parent"
                data-id="3b1c742"
                data-element_type="container"
                data-aos="fade-right"
                data-aos-offset="200" data-aos-easing="ease-in-sine" data-aos-duration="400"
                style={{ "--padding-top": "79px", "--padding-bottom": "76px" }}
            >
                <div
                    className="elementor-element elementor-element-5386d30 e-con-full e-flex e-con e-child"
                    data-id="5386d30"
                    data-element_type="container"
                >
                    <div
                        className="elementor-element elementor-element-ad3d20d elementor-widget elementor-widget-startpro_core_section_title"
                        data-id="ad3d20d"
                        data-element_type="widget"
                        data-widget_type="startpro_core_section_title.default"
                    >
                        <div className="elementor-widget-container">
                            <div className="qodef-shortcode qodef-m  qodef-section-title qodef-alignment--left ">
                                <h2 className="qodef-m-title">
                                    Our Promise
                                </h2>
                                <p style={{ fontSize: "18px", marginBottom: "0px" }}>   Insight. Innovation. Impact.</p>
                            </div>
                        </div>
                    </div>
                    <div
                        className="elementor-element elementor-element-6f1bb5b elementor-widget elementor-widget-startpro_core_button"
                        data-id="6f1bb5b"
                        data-element_type="widget"
                        data-widget_type="startpro_core_button.default"
                    >
                        <div className="elementor-widget-container">
                            <a
                                className="qodef-shortcode qodef-m  qodef-button qodef-layout--filled qodef-size--large qodef-html--link "
                                href="/about_us"
                                target="_self"
                            >
                                <span className="qodef-m-text">Read More</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div
                    className="elementor-element elementor-element-645a6e1 e-con-full e-flex e-con e-child"
                    data-id="645a6e1"
                    data-element_type="container"
                >
                    <div
                        className="elementor-element elementor-element-a40582d e-con-full e-flex e-con e-child"
                        data-id="a40582d"
                        data-element_type="container"
                    >
                        <div
                            className="elementor-element elementor-element-e23d48a e-con-full e-flex e-con e-child"
                            data-id="e23d48a"
                            data-element_type="container"
                        >
                            <div
                                className="elementor-element elementor-element-54e6ad5 elementor-widget elementor-widget-startpro_core_icon_with_text"
                                data-id="54e6ad5"
                                data-element_type="widget"
                                data-widget_type="startpro_core_icon_with_text.default"
                            >
                                <div className="elementor-widget-container">
                                    <div className="qodef-shortcode qodef-m  qodef-icon-with-text qodef-layout--top qodef--custom-icon qodef--retina qodef-alignment--left">
                                        <div className="qodef-m-icon-wrapper">
                                            <img
                                                loading="lazy"
                                                decoding="async"
                                                width={128}
                                                height={134}
                                                src="/img/strategic-vision.png"
                                                className="attachment-full size-full"
                                                alt="d"
                                            />{" "}
                                        </div>
                                        <div className="qodef-m-content">
                                            <h5 className="qodef-m-title" style={{ marginTop: 15 }} data-aos="fade-right"
                                                data-aos-offset="200" data-aos-delay="50" data-aos-duration="800">
                                                <span className="qodef-m-title-text">
                                                    Strategic Vision
                                                </span>
                                            </h5>
                                            <p data-aos="fade-right"
                                                data-aos-offset="200" data-aos-delay="50" data-aos-duration="900" className="qodef-m-text" style={{ marginTop: 6, fontSize: "13px", lineHeight: "1.5" }}>
                                                We harness deep industry insights and data-driven methodologies to develop actionable strategies tailored to your unique challenges.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="elementor-element elementor-element-60ad030 e-con-full e-flex e-con e-child"
                            data-id="60ad030"
                            data-element_type="container"
                        >
                            <div
                                className="elementor-element elementor-element-fa7e5af elementor-widget elementor-widget-startpro_core_icon_with_text"
                                data-id="fa7e5af"
                                data-element_type="widget"
                                data-widget_type="startpro_core_icon_with_text.default"
                            >
                                <div className="elementor-widget-container">
                                    <div className="qodef-shortcode qodef-m  qodef-icon-with-text qodef-layout--top qodef--custom-icon qodef--retina qodef-alignment--left">
                                        <div className="qodef-m-icon-wrapper">
                                            <img
                                                loading="lazy"
                                                decoding="async"
                                                width={134}
                                                height={134}
                                                src="/img/Transformative-Execution-01.png"
                                                className="attachment-full size-ful09l"
                                                alt="f"

                                                sizes="(max-width: 134px) 100vw, 134px"
                                            />{" "}
                                        </div>
                                        <div className="qodef-m-content">
                                            <h5 className="qodef-m-title" style={{ marginTop: 15 }} data-aos="fade-left"
                                                data-aos-offset="200" data-aos-delay="50" data-aos-duration="800">
                                                <span className="qodef-m-title-text">
                                                    Transformative Execution
                                                </span>
                                            </h5>
                                            <p data-aos="fade-left"
                                                data-aos-offset="200" data-aos-delay="50" data-aos-duration="900" className="qodef-m-text" style={{ marginTop: 6, fontSize: "13px", lineHeight: "1.5" }}>
                                                Whether managing high-stakes development projects or spearheading digital and operational transformation.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="elementor-element elementor-element-db50601 e-con-full e-flex e-con e-child"
                        data-id="db50601"
                        data-element_type="container"
                    >
                        <div
                            className="elementor-element elementor-element-df15ce9 e-con-full e-flex e-con e-child"
                            data-id="df15ce9"
                            data-element_type="container"
                        >
                            <div
                                className="elementor-element elementor-element-744950e elementor-widget elementor-widget-startpro_core_icon_with_text"
                                data-id="744950e"
                                data-element_type="widget"
                                data-widget_type="startpro_core_icon_with_text.default"
                            >
                                <div className="elementor-widget-container">
                                    <div className="qodef-shortcode qodef-m  qodef-icon-with-text qodef-layout--top qodef--custom-icon qodef--retina qodef-alignment--left">
                                        <div className="qodef-m-icon-wrapper">
                                            <img
                                                loading="lazy"
                                                decoding="async"
                                                width={136}
                                                height={134}
                                                src="/img/Collaborative-Partnership-01.png"
                                                className="attachment-full size-full"
                                                alt="d"

                                                sizes="(max-width: 136px) 100vw, 136px"
                                            />{" "}
                                        </div>
                                        <div className="qodef-m-content">
                                            <h5 className="qodef-m-title" style={{ marginTop: 15 }} data-aos="fade-right"
                                                data-aos-offset="200" data-aos-delay="50" data-aos-duration="800">
                                                <span className="qodef-m-title-text">
                                                    Collaborative Partnership
                                                </span>
                                            </h5>
                                            <p data-aos="fade-right"
                                                data-aos-offset="200" data-aos-delay="50" data-aos-duration="900" className="qodef-m-text" style={{ marginTop: 6, fontSize: "13px", lineHeight: "1.5" }}>
                                                We work closely with you to navigate complexity, foster innovation, and create lasting value that propels your business.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="elementor-element elementor-element-3f11832 e-con-full e-flex e-con e-child"
                            data-id="3f11832"
                            data-element_type="container"
                        >
                            <div
                                className="elementor-element elementor-element-62e9a85 elementor-widget elementor-widget-startpro_core_icon_with_text"
                                data-id="62e9a85"
                                data-element_type="widget"
                                data-widget_type="startpro_core_icon_with_text.default"
                            >
                                <div className="elementor-widget-container">
                                    <div className="qodef-shortcode qodef-m  qodef-icon-with-text qodef-layout--top qodef--custom-icon qodef--retina qodef-alignment--left">
                                        <div className="qodef-m-icon-wrapper">
                                            <img
                                                loading="lazy"
                                                decoding="async"
                                                width={128}
                                                height={134}
                                                src="/img/Insightful-decisions.png"
                                                className="attachment-full size-full"
                                                alt="d"
                                            />{" "}
                                        </div>
                                        <div className="qodef-m-content">
                                            <h5 className="qodef-m-title" style={{ marginTop: 15 }} data-aos="fade-left"
                                                data-aos-offset="200" data-aos-delay="50" data-aos-duration="900">
                                                <span className="qodef-m-title-text">
                                                    Insightful Decisions
                                                </span>
                                            </h5>
                                            <p data-aos="fade-left"
                                                data-aos-offset="200" data-aos-delay="50" data-aos-duration="900" className="qodef-m-text" style={{ marginTop: 6, fontSize: "13px", lineHeight: "1.5" }}>
                                                Leveraging Advanced Analytics to Develop Insightful Strategies That Drive Measurable and Impactful Business Outcomes.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>




            <div
                className="elementor-element elementor-element-03d0e4b e-con-full e-flex e-con e-parent e-lazyloaded"
                data-id="03d0e4b"
                data-element_type="container"
                data-settings='{"background_background":"classic"}'
            >
                <div
                    className="elementor-element elementor-element-097b6e7 e-con-full e-flex e-con e-child"
                    data-id="097b6e7"
                    data-element_type="container"
                    data-settings='{"background_background":"classic"}'
                    data-aos="fade-right"
                    data-aos-offset="200" data-aos-delay="200" data-aos-duration="600"
                >
                    <div
                        className="elementor-element elementor-element-cc008f2 elementor-widget__width-initial elementor-widget elementor-widget-startpro_core_single_image"
                        data-id="cc008f2"
                        data-element_type="widget"
                        data-widget_type="startpro_core_single_image.default"
                    >

                    </div>
                </div>
                <div
                    className="elementor-element elementor-element-2551925 e-con-full e-flex e-con e-child"
                    data-id="2551925"
                    data-element_type="container"


                    data-settings='{"background_background":"classic"}'
                >
                    <div
                        className="elementor-element elementor-element-ec98634 e-con-full e-flex e-con e-child"
                        data-id="ec98634"
                        data-element_type="container"
                        style={{ paddingBottom: "24px" }}
                    >
                        <div
                            className="elementor-element elementor-element-7d82ebd elementor-widget elementor-widget-startpro_core_highlight"
                            data-id="7d82ebd"
                            data-element_type="widget"
                            data-widget_type="startpro_core_highlight.default"
                        >
                            <div className="elementor-widget-container">
                                <h2
                                    className="qodef-shortcode qodef-m  qodef-highlight qodef-custom-font-48    "
                                    style={{ color: "#FFFFFF" }}
                                >
                                    What sets {""}
                                    <span
                                        className="qodef-highlight-text"
                                        style={{ color: "#FFBE3E" }}
                                    >
                                        us
                                        apart?

                                    </span>{" "}
                                    {" "}
                                </h2>
                            </div>
                        </div>
                        <div
                            className="elementor-element elementor-element-d7989bf elementor-widget elementor-widget-startpro_core_icon_list_item"
                            data-id="d7989bf"
                            data-element_type="widget"
                            data-widget_type="startpro_core_icon_list_item.default"
                        >
                            <div className="elementor-widget-container">
                                <div className="qodef-icon-list-item qodef-icon--icon-pack  hover-icon-bounce">
                                    <span className="qodef-e-title" style={{ color: "#FFFFFF" }}>
                                        <span className="qodef-e-title-inner ">
                                            <span
                                                className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--circle cms-eicon"
                                                style={{
                                                    margin: "0px 13px 0px 0px",
                                                    width: "26px",
                                                    height: "26px",
                                                    lineHeight: "26px",
                                                    backgroundColor: "#ffffff2b",
                                                }}
                                            >
                                                {" "}
                                                <span
                                                    className="qodef-icon-elegant-icons icon_check qodef-icon qodef-e"

                                                ></span>{" "}
                                            </span>{" "}
                                            <span className="qodef-e-title-text" style={{ fontSize: "14px", lineHeight: "1.5", fontWeight: "500" }}>
                                                Client-Centric Approach <br /><span style={{ fontWeight: "200" }}>
                                                    Tailored solutions aligned with your specific
                                                    goals, challenges, and growth vision.
                                                </span>
                                            </span>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div
                            className="elementor-element elementor-element-2635e73 elementor-widget elementor-widget-startpro_core_icon_list_item"
                            data-id="2635e73"
                            data-element_type="widget"
                            data-widget_type="startpro_core_icon_list_item.default"
                        >
                            <div className="elementor-widget-container">
                                <div className="qodef-icon-list-item qodef-icon--icon-pack  hover-icon-bounce">
                                    <span className="qodef-e-title" style={{ color: "#FFFFFF" }}>
                                        <span className="qodef-e-title-inner ">
                                            <span
                                                className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--circle cms-eicon"
                                                style={{
                                                    margin: '0px 13px 0px 0px', // Top, Right, Bottom, Left
                                                    width: '26px',               // Width of the element
                                                    height: '26px',              // Height of the element
                                                    lineHeight: '26px',          // Line height for vertical centering
                                                    backgroundColor: "#ffffff2b", // Background color
                                                }}
                                            >
                                                {" "}
                                                <span
                                                    className="qodef-icon-elegant-icons icon_check qodef-icon qodef-e"

                                                ></span>{" "}
                                            </span>{" "}
                                            <span className="qodef-e-title-text" style={{ fontSize: "14px", lineHeight: "1.5", fontWeight: "500" }}>Global Expertise, Local Insight
                                                <br /><span style={{ fontWeight: "200" }}> We bring world-class advisory practices
                                                    with deep-rooted understanding of regional
                                                    dynamics and market realities.</span>
                                            </span>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div
                            className="elementor-element elementor-element-14704cc elementor-widget elementor-widget-startpro_core_icon_list_item"
                            data-id="14704cc"
                            data-element_type="widget"
                            data-widget_type="startpro_core_icon_list_item.default"
                        >
                            <div className="elementor-widget-container">
                                <div className="qodef-icon-list-item qodef-icon--icon-pack hover-icon-bounce ">
                                    <span className="qodef-e-title" style={{ color: "#FFFFFF" }}>
                                        <span className="qodef-e-title-inner ">
                                            <span
                                                className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--circle cms-eicon"
                                                style={{
                                                    margin: '0px 13px 0px 0px', // Top, Right, Bottom, Left
                                                    width: '26px',               // Width of the element
                                                    height: '26px',              // Height of the element
                                                    lineHeight: '26px',          // Line height for vertical centering
                                                    backgroundColor: "#ffffff2b",  // Background color
                                                }}
                                            >
                                                {" "}
                                                <span
                                                    className="qodef-icon-elegant-icons icon_check qodef-icon qodef-e"

                                                ></span>{" "}
                                            </span>{" "}
                                            <span className="qodef-e-title-text" style={{ fontSize: "14px", lineHeight: "1.5", fontWeight: "500" }}>Proven Frameworks<br /><span style={{ fontWeight: "200" }}> Our strategies are backed by decades of
                                                hands-on experience and continuous
                                                refinement.</span>
                                            </span>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div
                            className="elementor-element elementor-element-c60095a elementor-widget elementor-widget-startpro_core_icon_list_item"
                            data-id="c60095a"
                            data-element_type="widget"
                            data-widget_type="startpro_core_icon_list_item.default"
                        >
                            <div className="elementor-widget-container">
                                <div className="qodef-icon-list-item qodef-icon--icon-pack hover-icon-bounce ">
                                    <span className="qodef-e-title" style={{ color: "#FFFFFF" }}>
                                        <span className="qodef-e-title-inner">
                                            <span
                                                className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--circle cms-eicon"
                                                style={{
                                                    margin: '0px 13px 0px 0px', // Top, Right, Bottom, Left
                                                    width: '26px',               // Width of the element
                                                    height: '26px',              // Height of the element
                                                    lineHeight: '26px',          // Line height for vertical centering
                                                    backgroundColor: "#ffffff2b",  // Background color
                                                }}
                                            >
                                                {" "}
                                                <span
                                                    className="qodef-icon-elegant-icons icon_check qodef-icon qodef-e"

                                                ></span>{" "}
                                            </span>{" "}
                                            <span className="qodef-e-title-text" style={{ fontSize: "14px", lineHeight: "1.5", fontWeight: "500" }}>
                                                Results-Oriented Delivery<br /><span style={{ fontWeight: "200" }}> Every engagement is designed to create
                                                    measurable impact and long-term value</span>

                                            </span>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        {/* <div
                                                    className="elementor-element elementor-element-8ab2248 elementor-widget elementor-widget-startpro_core_icon_list_item"
                                                    data-id="8ab2248"
                                                    data-element_type="widget"
                                                    data-widget_type="startpro_core_icon_list_item.default"
                                                >
                                                    <div className="elementor-widget-container">
                                                        <div className="qodef-icon-list-item qodef-icon--icon-pack  ">
                                                            <span className="qodef-e-title" style={{ color: "#FFFFFF" }}>
                                                                <span className="qodef-e-title-inner">
                                                                    <span
                                                                        className="qodef-shortcode qodef-m  qodef-icon-holder  qodef-layout--circle"
                                                                        style={{
                                                                            margin: '0px 13px 0px 0px', // Top, Right, Bottom, Left
                                                                            width: '26px',               // Width of the element
                                                                            height: '26px',              // Height of the element
                                                                            lineHeight: '26px',          // Line height for vertical centering
                                                                            backgroundColor: '#204447',  // Background color
                                                                        }}
                                                                    >
                                                                        {" "}
                                                                        <span
                                                                            className="qodef-icon-elegant-icons icon_check qodef-icon qodef-e"

                                                                        ></span>{" "}
                                                                    </span>{" "}
                                                                    <span className="qodef-e-title-text">Nusquam explicar</span>
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div> */}
                    </div>
                    <div
                        className="elementor-element elementor-element-0715fb2 elementor-widget elementor-widget-startpro_core_button"
                        data-id="0715fb2"
                        data-element_type="widget"
                        data-widget_type="startpro_core_button.default"
                    >
                        <div className="elementor-widget-container">
                            <a
                                className="qodef-shortcode qodef-m  qodef-button qodef-layout--filled  qodef-html--link "
                                href="/contact_us"
                                target="_self"
                                style={{
                                    '--qode-button-color': '#144443',
                                    '--qode-button-hover-color': '#144443',
                                    '--qode-button-bg-color': '#FFFFFF',
                                    '--qode-button-bg-hover-color': '#FFFFFF',
                                    '--qode-button-border-color': '#FFFFFF',
                                    '--qode-button-border-hover-color': '#FFFFFF',
                                    padding: '10px 20px', // Example padding
                                    border: '2px solid var(--qode-button-border-color)', // Using the custom property
                                    backgroundColor: 'var(--qode-button-bg-color)', // Using the custom property
                                    color: 'var(--qode-button-color)', // Using the custom property
                                    cursor: 'pointer', // Change cursor to pointer
                                    transition: 'background-color 0.3s, color 0.3s', // Smooth transition for hover effects
                                }}
                            >
                                <span className="qodef-m-text">Free consultation</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <ContentSection {...firstSectionData} />

            <Demo />

            <div
                className="elementor-element elementor-element-6f8e5dd e-con-full e-flex e-con e-parent e-lazyloaded"
                data-id="6f8e5dd"
                data-element_type="container"
                data-settings='{"background_background":"classic"}'
            >
                <div
                    className="elementor-element elementor-element-3b03e73 e-con-full qodef-elementor-content-grid e-flex e-con e-child"
                    data-id="3b03e73"
                    data-element_type="container"
                >
                    <div
                        className="elementor-element elementor-element-21870bd e-con-full e-flex e-con e-child"
                        data-id="21870bd"
                        data-element_type="container"
                    >
                        <div
                            className="elementor-element elementor-element-018a019 elementor-widget elementor-widget-startpro_core_counter"
                            data-id="018a019"
                            data-element_type="widget"
                            data-widget_type="startpro_core_counter.default"
                        >
                            <div className="elementor-widget-container">
                                <div
                                    className="qodef-shortcode qodef-m  qodef-counter qodef-layout--simple "
                                    data-start-digit={1}
                                    data-end-digit={12}
                                    data-digit-label=" months"
                                >
                                    <Counter start={1} end={12} suffix=" months" />
                                    <div className="qodef-m-content">
                                        <span className="qodef-m-title">Revenues brought forward </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="elementor-element elementor-element-02ccd10 e-con-full e-flex e-con e-child"
                        data-id="02ccd10"
                        data-element_type="container"
                    >
                        <div
                            className="elementor-element elementor-element-7ba9346 elementor-widget elementor-widget-startpro_core_counter"
                            data-id="7ba9346"
                            data-element_type="widget"
                            data-widget_type="startpro_core_counter.default"
                        >
                            <div className="elementor-widget-container">
                                <div
                                    className="qodef-shortcode qodef-m  qodef-counter qodef-layout--simple "
                                    data-start-digit={1}
                                    data-end-digit={60}
                                    data-step-digit={3}
                                    data-digit-label="%"
                                >
                                    <Counter start={1} end={60} step={3} suffix="%" />

                                    <div className="qodef-m-content">
                                        <span className="qodef-m-title">Average company growth </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        className="elementor-element elementor-element-cc2b2f2 e-con-full e-flex e-con e-child"
                        data-id="cc2b2f2"
                        data-element_type="container"
                    >
                        <div
                            className="elementor-element elementor-element-a56e730 elementor-widget elementor-widget-startpro_core_counter"
                            data-id="a56e730"
                            data-element_type="widget"
                            data-widget_type="startpro_core_counter.default"
                        >
                            <div className="elementor-widget-container">
                                <div
                                    className="qodef-shortcode qodef-m  qodef-counter qodef-layout--simple "
                                    data-start-digit={1}
                                    data-end-digit={13}
                                    data-digit-label=" industries"
                                >
                                    <Counter start={1} end={13} suffix=" industries" />
                                    <div className="qodef-m-content">
                                        <span className="qodef-m-title">We’ve got you covered </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ContentSection {...secondSectionData} />
            <FAQ />
            <div
                className="elementor-element elementor-element-999b167 e-con-full e-flex e-con e-parent e-lazyloaded"
                data-id="999b167"
                data-element_type="container"
                data-settings='{"background_background":"classic"}'
            >
                <div
                    className="elementor-element elementor-element-a9e12fe elementor-widget__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-startpro_core_section_title"
                    data-id="a9e12fe"
                    data-element_type="widget"
                    data-widget_type="startpro_core_section_title.default"
                >
                    <div className="elementor-widget-container">
                        <div className="qodef-shortcode qodef-m  qodef-section-title qodef-alignment--left ">
                            <h2 className="qodef-m-title" style={{ color: "#FFFFFF" }}>
                                Let’s Connect!{" "}
                            </h2>
                            <p
                                className="qodef-m-description"
                                style={{ marginTop: 8, color: "#FFFFFF" }}
                            >
                                We’d love to hear from you. Whether you have a question, need assistance, or just want to chat, feel free to reach out.
                                {" "}
                            </p>
                        </div>
                    </div>
                </div>
                <div
                    className="elementor-element elementor-element-a734e4a elementor-widget__width-initial elementor-widget-mobile__width-inherit elementor-widget elementor-widget-wp-widget-startpro_core_contact_form_7"
                    data-id="a734e4a"
                    data-element_type="widget"
                    data-widget_type="wp-widget-startpro_core_contact_form_7.default"
                >
                    <div className="elementor-widget-container">
                        <div className="qodef-contact-form-7 qodef-skin--light">
                            <div
                                className="wpcf7 js"
                                id="wpcf7-f2421-p18-o1"
                                lang="en-US"
                                dir="ltr"
                                data-wpcf7-id={2421}
                            >
                                <div className="screen-reader-response">
                                    <p role="status" aria-live="polite" aria-atomic="true" /> <ul />
                                </div>
                                <form
                                    action="/home"
                                    method="post"
                                    className="wpcf7-form init demo"
                                    aria-label="Contact form"
                                    noValidate="novalidate"
                                    data-status="init"
                                >
                                    <div style={{ display: "none" }}>
                                        <input type="hidden" name="_wpcf7" defaultValue={2421} />
                                        <input type="hidden" name="_wpcf7_version" defaultValue="6.0.3" />
                                        <input type="hidden" name="_wpcf7_locale" defaultValue="en_US" />
                                        <input
                                            type="hidden"
                                            name="_wpcf7_unit_tag"
                                            defaultValue="wpcf7-f2421-p18-o1"
                                        />
                                        <input
                                            type="hidden"
                                            name="_wpcf7_container_post"
                                            defaultValue={18}
                                        />
                                        <input
                                            type="hidden"
                                            name="_wpcf7_posted_data_hash"
                                            defaultValue=""
                                        />
                                    </div>
                                    <span className="wpcf7-form-control-wrap" data-name="your-name">
                                        <input
                                            size={40}
                                            maxLength={400}
                                            className="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                                            autoComplete="name"
                                            aria-required="true"
                                            aria-invalid="false"
                                            placeholder="Name"
                                            defaultValue=""
                                            type="text"
                                            name="your-name"
                                        />
                                    </span>
                                    <span className="wpcf7-form-control-wrap" data-name="your-email">
                                        <input
                                            size={40}
                                            maxLength={400}
                                            className="wpcf7-form-control wpcf7-email wpcf7-validates-as-required wpcf7-text wpcf7-validates-as-email"
                                            autoComplete="email"
                                            aria-required="true"
                                            aria-invalid="false"
                                            placeholder="E-mail address"
                                            defaultValue=""
                                            type="email"
                                            name="your-email"
                                        />
                                    </span>
                                    <span className="wpcf7-form-control-wrap" data-name="your-message">
                                        <textarea
                                            cols={40}
                                            rows={10}
                                            maxLength={2000}
                                            className="wpcf7-form-control wpcf7-textarea"
                                            aria-invalid="false"
                                            placeholder="Message"
                                            name="your-message"
                                            defaultValue={""}
                                        />
                                    </span>
                                    <button
                                        className="wpcf7-form-control wpcf7-submit qodef-button qodef-size--normal qodef-layout--filled qodef-m"
                                        type="submit"
                                    >
                                        <span className="qodef-m-text">Send message</span>
                                    </button>
                                    <div className="wpcf7-response-output" aria-hidden="true" />
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Home
